module.exports = "https://health.dajiuxing.com.cn/img/assets/sharing/bind.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Fsharing%2Fbind.png
// module id = rW9r
// module chunks = 93